var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"text-transform":"uppercase"},attrs:{"plain":"","to":"/dashboard/fanfestEvent/edit"}},[_vm._v(_vm._s(_vm.$tc('form.create'))+" "+_vm._s(_vm.$tc('fanfestEvent.objectName'))+" "),_c('v-icon',[_vm._v("add_box")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }